import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationIT from "./locales/it/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  it: {
    translation: translationIT,
  },
};

i18n
  .use(LanguageDetector) // detect user broswer language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "it",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: true
    },
  });

export default i18n;
